
 // Company details shared by every landing page. Change here, not in page files.
export const site = {
  name: "Onbbits",
  legalName: "Onbbits Innovation Pvt. Ltd.",
  cin: "U62091GJ2026PTC172071",
  logoUrl: "https://onbbits.io/logo.svg",

  // Official Meta Tech Provider badge.
  // Empty = text badge.
  metaBadgeUrl: "",

  phoneDisplay: "+91 97270 77732",
  phoneHref: "tel:+919727077732",
  email: "info@onbbits.io",

  // WhatsApp number with country code, digits only.
  whatsappNumber: "919727077732",

  address:
    "912, International Finance Center, VIP Road, Vesu, Surat, Gujarat 395007",

  links: {
    home: "https://onbbits.io",
    pricing: "https://onbbits.io/pricing",
    privacy: "https://onbbits.io/privacy-policy",
    terms: "https://onbbits.io/terms-conditions",
    refund: "https://onbbits.io/cancellation-refund",
    cookies: "https://onbbits.io/cookie-policy",
    messageCharges: "https://onbbits.io/message-template-charges.pdf",
  },
};

export function whatsappLink(text) {
  return `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(text)}`;
}
